import type { Tracker } from './tracker';

let tefComs: HTMLElement;

interface Service {
  bindTefComs: (wc: HTMLElement) => void;
  logInfo: (...args: unknown[]) => void;
  logError: (...args: unknown[]) => void;
  fireEvent: (name: string, details: Record<string, string>) => void;
  fireError: (name: string, details: Record<string, string>) => void;
  fireInfo: (name: string, details: object) => void;
  scrollToTop: () => void;
  tracker: Tracker;
}

export const service: Service = {
  bindTefComs: (wc: HTMLElement) => {
    tefComs = wc;
  },

  logInfo: (...args: unknown[]) => {
    // eslint-disable-next-line no-console
    console.info(`tef-coms: ${args.map((arg) => String(<string>arg)).join(', ')}`);
  },

  logError(...args: unknown[]) {
    // eslint-disable-next-line no-console
    console.error(`tef-coms: ${args.map((arg) => String(<string>arg)).join(', ')}`);
  },

  fireEvent: (name: string, details: Record<string, string> = {}) => {
    const event = new CustomEvent('tef-coms', {
      bubbles: true,
      composed: true, // pass through shadow DOM boundaries
      detail: {
        name,
        ...details,
      },
    });
    tefComs.dispatchEvent(event);
  },

  fireError: (name: string, details = {}) => {
    service.fireEvent(name, { level: 'error', ...details });
  },

  fireInfo: (name: string, details = {}) => {
    service.fireEvent(name, { level: 'info', ...details });
  },

  scrollToTop: () => {
    tefComs.scrollIntoView({ behavior: 'smooth' });
  },

  tracker: {

    reduxActionListener: (_ignored: unknown) => {},

    doTracking: () => {},
  },
};
